<div class="hero-text"><h1>Sips AI helps companies get started with Artificial Intelligence</h1>
</div>